/*
 * @providesModule Country
 *
 */

import _ from 'lodash';
import country_data from './Countries.json';

export interface CountryType {
  name: string;
  iso2: string;
  dialCode: string;
  priority: number;
  areaCodes: string[] | null;
}

const countries: CountryType[] = country_data;

class Country {
  private static instance: Country | null = null;
  private countryCodes: Record<string, string[]> = {};
  private sortedCountries: CountryType[] | null = null;

  private constructor() {}

  static getInstance(): Country {
    if (!Country.instance) {
      Country.instance = new Country();
    }
    return Country.instance;
  }

  addCountryCode(iso2: string, dialCode: string, priority?: number): void {
    if (!this.countryCodes[dialCode]) {
      this.countryCodes[dialCode] = [];
    }

    const index = priority ?? 0;
    this.countryCodes[dialCode]![index] = iso2;
  }

  getAll(): CountryType[] {
    if (!this.sortedCountries) {
      this.sortedCountries = _.orderBy(countries, ['name'], ['asc']);
    }
    return this.sortedCountries;
  }

  getCountryCodes(): Record<string, string[]> {
    if (Object.keys(this.countryCodes).length === 0) {
      this.getAll().forEach((country) => {
        this.addCountryCode(country.iso2, country.dialCode, country.priority);
        if (country.areaCodes) {
          country.areaCodes.forEach((areaCode) => {
            this.addCountryCode(country.iso2, `${country.dialCode}${areaCode}`);
          });
        }
      });
    }
    return this.countryCodes;
  }

  getCountryDataByCode(iso2: string): CountryType | undefined {
    return _.find(this.getAll(), (country) => country.iso2 === iso2);
  }
}

export default Country.getInstance();
